export default __webpack_public_path__ + "static/media/tcdd.54d802d0.png";